import { useQuery } from '@tanstack/react-query';
import { useApiClients } from '../../client/api/useApiClient';
import Dashboard from '../../views/Dashboard';
import { GetHomeInsightsResponseDto } from '@EHSNavigator/backend';
import Loader from '../../components/Loader';

export default function DashboardPage() {
  const { StatisticsApi } = useApiClients();
  const { data, isLoading, isPending } = useQuery<
    GetHomeInsightsResponseDto,
    Error,
    any
  >({
    queryKey: ['statistics-stats'],
    queryFn: async () => {
      const response =
        await StatisticsApi?.statisticsControllerGetHomeInsights();
      return response?.data || [];
    },
  });

  if (isLoading || isPending) {
    return <Loader />;
  }

  return (
    <main className="">
      <Dashboard data={data} />
    </main>
  );
}
